/**
 * @fileoverview gRPC-Web generated client stub for customers_role_privilege_endpoint
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.1
// 	protoc              v6.32.1
// source: roleprivilege.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as roleprivilege_pb from './roleprivilege_pb'; // proto import: "roleprivilege.proto"


export class RolePrivilegeEndpointClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorAdd = new grpcWeb.MethodDescriptor(
    '/customers_role_privilege_endpoint.RolePrivilegeEndpoint/Add',
    grpcWeb.MethodType.UNARY,
    roleprivilege_pb.AddRolePrivilegeRequest,
    roleprivilege_pb.AddRolePrivilegeResponse,
    (request: roleprivilege_pb.AddRolePrivilegeRequest) => {
      return request.serializeBinary();
    },
    roleprivilege_pb.AddRolePrivilegeResponse.deserializeBinary
  );

  add(
    request: roleprivilege_pb.AddRolePrivilegeRequest,
    metadata?: grpcWeb.Metadata | null): Promise<roleprivilege_pb.AddRolePrivilegeResponse>;

  add(
    request: roleprivilege_pb.AddRolePrivilegeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: roleprivilege_pb.AddRolePrivilegeResponse) => void): grpcWeb.ClientReadableStream<roleprivilege_pb.AddRolePrivilegeResponse>;

  add(
    request: roleprivilege_pb.AddRolePrivilegeRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: roleprivilege_pb.AddRolePrivilegeResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/customers_role_privilege_endpoint.RolePrivilegeEndpoint/Add',
        request,
        metadata || {},
        this.methodDescriptorAdd,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/customers_role_privilege_endpoint.RolePrivilegeEndpoint/Add',
    request,
    metadata || {},
    this.methodDescriptorAdd);
  }

  methodDescriptorAddBatch = new grpcWeb.MethodDescriptor(
    '/customers_role_privilege_endpoint.RolePrivilegeEndpoint/AddBatch',
    grpcWeb.MethodType.UNARY,
    roleprivilege_pb.AddBatchRolePrivilegeRequest,
    roleprivilege_pb.AddBatchRolePrivilegeResponse,
    (request: roleprivilege_pb.AddBatchRolePrivilegeRequest) => {
      return request.serializeBinary();
    },
    roleprivilege_pb.AddBatchRolePrivilegeResponse.deserializeBinary
  );

  addBatch(
    request: roleprivilege_pb.AddBatchRolePrivilegeRequest,
    metadata?: grpcWeb.Metadata | null): Promise<roleprivilege_pb.AddBatchRolePrivilegeResponse>;

  addBatch(
    request: roleprivilege_pb.AddBatchRolePrivilegeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: roleprivilege_pb.AddBatchRolePrivilegeResponse) => void): grpcWeb.ClientReadableStream<roleprivilege_pb.AddBatchRolePrivilegeResponse>;

  addBatch(
    request: roleprivilege_pb.AddBatchRolePrivilegeRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: roleprivilege_pb.AddBatchRolePrivilegeResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/customers_role_privilege_endpoint.RolePrivilegeEndpoint/AddBatch',
        request,
        metadata || {},
        this.methodDescriptorAddBatch,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/customers_role_privilege_endpoint.RolePrivilegeEndpoint/AddBatch',
    request,
    metadata || {},
    this.methodDescriptorAddBatch);
  }

  methodDescriptorDelete = new grpcWeb.MethodDescriptor(
    '/customers_role_privilege_endpoint.RolePrivilegeEndpoint/Delete',
    grpcWeb.MethodType.UNARY,
    roleprivilege_pb.DeleteRolePrivilegeRequest,
    roleprivilege_pb.DeleteRolePrivilegeResponse,
    (request: roleprivilege_pb.DeleteRolePrivilegeRequest) => {
      return request.serializeBinary();
    },
    roleprivilege_pb.DeleteRolePrivilegeResponse.deserializeBinary
  );

  delete(
    request: roleprivilege_pb.DeleteRolePrivilegeRequest,
    metadata?: grpcWeb.Metadata | null): Promise<roleprivilege_pb.DeleteRolePrivilegeResponse>;

  delete(
    request: roleprivilege_pb.DeleteRolePrivilegeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: roleprivilege_pb.DeleteRolePrivilegeResponse) => void): grpcWeb.ClientReadableStream<roleprivilege_pb.DeleteRolePrivilegeResponse>;

  delete(
    request: roleprivilege_pb.DeleteRolePrivilegeRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: roleprivilege_pb.DeleteRolePrivilegeResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/customers_role_privilege_endpoint.RolePrivilegeEndpoint/Delete',
        request,
        metadata || {},
        this.methodDescriptorDelete,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/customers_role_privilege_endpoint.RolePrivilegeEndpoint/Delete',
    request,
    metadata || {},
    this.methodDescriptorDelete);
  }

  methodDescriptorGetRolePrivileges = new grpcWeb.MethodDescriptor(
    '/customers_role_privilege_endpoint.RolePrivilegeEndpoint/GetRolePrivileges',
    grpcWeb.MethodType.UNARY,
    roleprivilege_pb.GetRolePrivilegesRequest,
    roleprivilege_pb.GetRolePrivilegesResponse,
    (request: roleprivilege_pb.GetRolePrivilegesRequest) => {
      return request.serializeBinary();
    },
    roleprivilege_pb.GetRolePrivilegesResponse.deserializeBinary
  );

  getRolePrivileges(
    request: roleprivilege_pb.GetRolePrivilegesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<roleprivilege_pb.GetRolePrivilegesResponse>;

  getRolePrivileges(
    request: roleprivilege_pb.GetRolePrivilegesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: roleprivilege_pb.GetRolePrivilegesResponse) => void): grpcWeb.ClientReadableStream<roleprivilege_pb.GetRolePrivilegesResponse>;

  getRolePrivileges(
    request: roleprivilege_pb.GetRolePrivilegesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: roleprivilege_pb.GetRolePrivilegesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/customers_role_privilege_endpoint.RolePrivilegeEndpoint/GetRolePrivileges',
        request,
        metadata || {},
        this.methodDescriptorGetRolePrivileges,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/customers_role_privilege_endpoint.RolePrivilegeEndpoint/GetRolePrivileges',
    request,
    metadata || {},
    this.methodDescriptorGetRolePrivileges);
  }

  methodDescriptorGetRolePrivilege = new grpcWeb.MethodDescriptor(
    '/customers_role_privilege_endpoint.RolePrivilegeEndpoint/GetRolePrivilege',
    grpcWeb.MethodType.UNARY,
    roleprivilege_pb.GetRolePrivilegeRequest,
    roleprivilege_pb.GetRolePrivilegeResponse,
    (request: roleprivilege_pb.GetRolePrivilegeRequest) => {
      return request.serializeBinary();
    },
    roleprivilege_pb.GetRolePrivilegeResponse.deserializeBinary
  );

  getRolePrivilege(
    request: roleprivilege_pb.GetRolePrivilegeRequest,
    metadata?: grpcWeb.Metadata | null): Promise<roleprivilege_pb.GetRolePrivilegeResponse>;

  getRolePrivilege(
    request: roleprivilege_pb.GetRolePrivilegeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: roleprivilege_pb.GetRolePrivilegeResponse) => void): grpcWeb.ClientReadableStream<roleprivilege_pb.GetRolePrivilegeResponse>;

  getRolePrivilege(
    request: roleprivilege_pb.GetRolePrivilegeRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: roleprivilege_pb.GetRolePrivilegeResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/customers_role_privilege_endpoint.RolePrivilegeEndpoint/GetRolePrivilege',
        request,
        metadata || {},
        this.methodDescriptorGetRolePrivilege,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/customers_role_privilege_endpoint.RolePrivilegeEndpoint/GetRolePrivilege',
    request,
    metadata || {},
    this.methodDescriptorGetRolePrivilege);
  }

  methodDescriptorUpdate = new grpcWeb.MethodDescriptor(
    '/customers_role_privilege_endpoint.RolePrivilegeEndpoint/Update',
    grpcWeb.MethodType.UNARY,
    roleprivilege_pb.UpdateRolePrivilegeRequest,
    roleprivilege_pb.UpdateRolePrivilegeResponse,
    (request: roleprivilege_pb.UpdateRolePrivilegeRequest) => {
      return request.serializeBinary();
    },
    roleprivilege_pb.UpdateRolePrivilegeResponse.deserializeBinary
  );

  update(
    request: roleprivilege_pb.UpdateRolePrivilegeRequest,
    metadata?: grpcWeb.Metadata | null): Promise<roleprivilege_pb.UpdateRolePrivilegeResponse>;

  update(
    request: roleprivilege_pb.UpdateRolePrivilegeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: roleprivilege_pb.UpdateRolePrivilegeResponse) => void): grpcWeb.ClientReadableStream<roleprivilege_pb.UpdateRolePrivilegeResponse>;

  update(
    request: roleprivilege_pb.UpdateRolePrivilegeRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: roleprivilege_pb.UpdateRolePrivilegeResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/customers_role_privilege_endpoint.RolePrivilegeEndpoint/Update',
        request,
        metadata || {},
        this.methodDescriptorUpdate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/customers_role_privilege_endpoint.RolePrivilegeEndpoint/Update',
    request,
    metadata || {},
    this.methodDescriptorUpdate);
  }

}

